import { customerStatusInSmall } from "./formate-functions"

export const generateServiceDarReport = (data) => {
    const draft = {
        revenue: 0,
        spare_amount: 0,
        call: 0,
        all_works: 0,
        repeat_works: 0,
        above_24_works: 0,
        extra_works: 0,
        working_time: 0,
        renewals: {
            amc: { count: 0, total_time: 0 },
            ssp: { count: 0, total_time: 0 }
        },
        services: {
            amc: { count: 0, total_time: 0 },
            ssp: { count: 0, total_time: 0 },
            iw: { count: 0, total_time: 0 },
            ow: { count: 0, total_time: 0 },
            oc: { count: 0, total_time: 0 }
        },
        complaints: {
            amc: { count: 0, total_time: 0 },
            ssp: { count: 0, total_time: 0 },
            iw: { count: 0, total_time: 0 },
            ow: { count: 0, total_time: 0 },
            oc: { count: 0, total_time: 0 }
        }
    }

    data?.map((work) => {
        // Revenue
        draft.revenue = draft?.revenue + Number(work?.total_amount || 0)

        // Spare Amount
        draft.spare_amount = draft?.spare_amount + Number(work?.spare_receivable_amount || 0)

        // Call
        draft.call = draft?.call + Number(work?.call_details?.primary_secondary || 0) + Number(work?.call_details?.extra_work || 0) + Number(work?.call_details?.above_24_kms || 0)

        // all_works
        draft.all_works++

        // repeat_works
        if (work?.repeat) {
            draft.repeat_works++
        }

        // above_24_works
        if (work?.call_details?.above_24_kms) {
            draft.above_24_works++
        }

        // extra_works
        if (work?.call_details?.extra_work) {
            draft.extra_works++
        }

        // working time
        draft.working_time = draft?.working_time + Number(work?.duration || 0)

        // Renewal
        if (work?.work_method === 'ssp package renewal') {
            draft.renewals.ssp.count++
            draft.renewals.ssp.total_time = draft?.renewals?.ssp?.total_time + Number(work?.duration || 0)
        } else if (work?.work_method === 'amc package renewal') {
            draft.renewals.amc.count++
            draft.renewals.amc.total_time = draft?.renewals?.amc?.total_time + Number(work?.duration || 0)
        }

        // Service
        if (work?.work_method === 'periodical service') {
            draft.services[customerStatusInSmall(work?.purifier_customer_status)].count++
            draft.services[customerStatusInSmall(work?.purifier_customer_status)].total_time = draft?.services[customerStatusInSmall(work?.purifier_customer_status)]?.total_time + Number(work?.duration || 0)
        }

        // complaints
        if (work?.work_method === 'complaint') {
            draft.complaints[customerStatusInSmall(work?.purifier_customer_status)].count++
            draft.complaints[customerStatusInSmall(work?.purifier_customer_status)].total_time = draft?.complaints[customerStatusInSmall(work?.purifier_customer_status)]?.total_time + Number(work?.duration || 0)
        }
    })

    return draft

}